import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { combiner, featureKey } from './combiner';

import { GetPolicyEffects } from './getPolicy/effects';
import { GetPolicyService } from './getPolicy/service';
import { PutPolicyEffects } from './putPolicy/effects';
import { PutPolicyService } from './putPolicy/service';
import { PolicyActionsEffects } from './actions/effects';
import { PolicyActionsService } from './actions/service';
import { DifferenceEffects } from './difference/effects';
import { DifferenceService } from './difference/service';

@NgModule({
  imports: [
    EffectsModule.forFeature([GetPolicyEffects, PutPolicyEffects, PolicyActionsEffects, DifferenceEffects]),
    StoreModule.forFeature(featureKey, combiner),
  ],
  providers: [GetPolicyService, PutPolicyService, PolicyActionsService, DifferenceService],
})
export class PolicyStoreModule {}
